import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import "core-js/modules/es.number.constructor.js";
import isFinite from "lodash/isFinite";
import { defineComponent as _defineComponent } from 'vue';
import { onBeforeMount, onMounted, ref, watch } from 'vue';
import { CountUp } from 'countup.js';
var __default__ = {
    name: 'XCountUp'
};
export default /*#__PURE__*/ _defineComponent(_object_spread_props(_object_spread({}, __default__), {
    props: {
        endVal: {
            type: Number,
            default: 0
        },
        autoplay: {
            type: Boolean,
            default: true
        },
        delay: {
            type: Number,
            default: 300
        },
        separator: {
            //组件里使用 组件里直接设置options不生效？
            type: String,
            default: ''
        },
        duration: {
            //组件里使用
            type: Number,
            default: 1.5
        },
        options: Object
    },
    setup: function setup(__props, param) {
        var expose = param.expose;
        var props = __props;
        var instance = null;
        // @exposed-api
        var printValue = function printValue(value) {
            if (!instance) return;
            instance.printValue(value);
        };
        // @exposed-api
        var start = function start(callback) {
            if (!instance) return;
            instance.start(callback);
        };
        // @exposed-api
        var pauseResume = function pauseResume() {
            if (!instance) return;
            instance.pauseResume();
        };
        // @exposed-api
        var reset = function reset() {
            if (!instance) return;
            instance.reset();
        };
        // @exposed-api
        var update = function update(newEndVal) {
            if (!instance) return;
            instance.update(newEndVal);
        };
        // @exposed-api
        var destroy = function destroy() {
            instance = null;
        };
        var countup = ref(null);
        onMounted(function() {
            if (countup.value == null) {
                return;
            }
            instance = new CountUp(countup.value, props.endVal, _object_spread({
                duration: props.duration,
                separator: props.separator
            }, props.options));
            if (props.autoplay) {
                setTimeout(function() {
                    start();
                }, props.delay);
            }
        });
        onBeforeMount(function() {
            destroy();
        });
        watch(function() {
            return props.endVal;
        }, function(v) {
            if (!isFinite(v)) return;
            update(v);
        });
        expose({
            printValue: printValue,
            start: start,
            pauseResume: pauseResume,
            reset: reset,
            update: update,
            destroy: destroy
        });
        return {
            __sfc: true,
            props: props,
            instance: instance,
            printValue: printValue,
            start: start,
            pauseResume: pauseResume,
            reset: reset,
            update: update,
            destroy: destroy,
            countup: countup
        };
    }
}));
